import { Loader } from '@mews-commander/ui';
import { SentryTeams } from '@mews/enums';
import { Container } from '@optimus-web/core';
import { SentryErrorBoundary, useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { DepositLedgerHighlightCards } from './components/DepositLedgerHighlightCards';
import { DepositLedgerTable } from './components/DepositLedgerTable';
import { DepositLedgerFilterProvider } from './context/DepositLedgerFilterContext';
import { DepositLedgerHeader } from './components/DepositLedgerHeader';

export const DepositLedger = () => {
    const showDatePicker = useFeatureFlag(FeatureFlag.trialBalanceFrontendEnabled);
    return (
        <SentryErrorBoundary team={SentryTeams.Accounting} fallback={<Loader />}>
            <Container overflowY="auto">
                <DepositLedgerFilterProvider>
                    {showDatePicker && <DepositLedgerHeader />}
                    <DepositLedgerHighlightCards />
                    <Container padding={['100', '300']} data-test-id="deposit-ledger-table">
                        <DepositLedgerTable />
                    </Container>
                </DepositLedgerFilterProvider>
            </Container>
        </SentryErrorBoundary>
    );
};
